import ReactSwitch from '@Shared/Components/Switch';
import { router, usePage } from '@inertiajs/react';
import Button from '@Web/Src/Components/Button';
import { useState } from 'react';

function PricingTable() {
    const [yearlyOn, setYearlyOn] = useState(false);

    const subscriptions = yearlyOn
        ? usePage().props.data.subscriptions.yearly.plans
        : usePage().props.data.subscriptions.monthly.plans;
    const features = usePage().props.data.features;
    const starterFeatures = subscriptions.starter.features;
    const basicFeatures = subscriptions.basic.features;
    const proFeatures = subscriptions.pro.features;
    const enterpriseFeatures = subscriptions.enterprise.features;

    const handleRegister = (isDemoRout) => {
        isDemoRout
            ? router.visit(route('web.pages.demo'))
            : router.visit(route('customer.auth.register'));
    };

    const handleChangePlanType = () => {
        setYearlyOn(!yearlyOn);
    };

    return (
        <div className={'mx-auto mt-28 w-full'} id={'pricing-table'}>
            <table className={'text-dark medium:hidden table w-full'}>
                <thead className={'sticky top-0 z-20 bg-[rgba(255,255,255,0.9)]'}>
                    <tr>
                        <th className={'text-left'}>
                            <h2 className={'pt-2 text-2xl font-bold'}>{__('Site plans')}</h2>
                            <div className={'mt-3 flex items-center gap-2.5'}>
                                <p className={'font-normal'}>{__('Annual discount')}</p>
                                <ReactSwitch
                                    id='toggle-plan'
                                    isOn={yearlyOn}
                                    handleToggle={handleChangePlanType}
                                />
                            </div>
                        </th>
                        {Object.values(subscriptions).map((plan, index) => {
                            const isProOrEnterprise =
                                plan.name.toLowerCase() === 'pro' ||
                                plan.name.toLowerCase() === 'enterprise';
                            const buttonLabel = isProOrEnterprise
                                ? __('Get a demo')
                                : __('Start free Trial');
                            const buttonContainerType = isProOrEnterprise ? 'main' : 'second';

                            return (
                                <th key={index}>
                                    <div
                                        className={
                                            'flex flex-col items-center pb-5 text-left'
                                        }
                                    >
                                        <h2 className={'text-2xl font-bold'}>{plan.name}</h2>
                                        <p className={'mt-3 text-xl font-normal'}>
                                            ${plan.price['usd'] / 100}
                                            <span>/ month</span>
                                        </p>
                                        <p className='text-tertiary h-4 pt-1'>
                                            {yearlyOn
                                                ? `$${(plan.price['usd'] / 100) * 12} annually`
                                                : ''}
                                        </p>
                                        <Button
                                            containerType={buttonContainerType}
                                            onClick={() => handleRegister(isProOrEnterprise)}
                                            className={`${isProOrEnterprise ? '' : '!text-blue hover:!text-light'} mt-3 w-[135px] !min-w-32 !text-base !font-semibold`}
                                            name={buttonLabel}
                                        />
                                    </div>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {Object.values(features).map((feature, index) => {
                        return (
                            <tr
                                key={index}
                                className={`${feature.key === 'paypal_payout' && 'opacity-60'} odd:bg-surface-input relative h-12 align-middle`}
                            >
                                <th className={'rounded-l-3xl pl-4 text-left align-middle'}>
                                    <div className={'flex items-center'}>
                                        {feature.link ? (
                                            <a
                                                className={'underline hover:opacity-90'}
                                                href={feature.link}
                                            >
                                                {feature.label}
                                            </a>
                                        ) : (
                                            <span>{feature.label}</span>
                                        )}
                                        {feature.tooltip && (
                                            <div>
                                                <div className='group relative flex cursor-pointer justify-center'>
                                                    <span
                                                        data-tooltip-target={feature.type}
                                                        className={
                                                            'group ml-2 flex items-center justify-center'
                                                        }
                                                    >
                                                        <img
                                                            src={
                                                                '/assets/images/svg/web/info-circle.svg'
                                                            }
                                                            alt={
                                                                'referral software info circle'
                                                            }
                                                        />
                                                    </span>
                                                    <span className='bg-dark text-light absolute left-full top-1/2 z-30 w-32 -translate-y-1/2 scale-0 rounded p-2 text-xs transition-all group-hover:scale-100'>
                                                        {feature.tooltip}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                        {feature.key === 'paypal_payout' && (
                                            <span
                                                className={
                                                    'text-yellow absolute left-[18%] top-1/2 block -translate-y-1/2 p-2 before:absolute before:left-1/2 before:top-1/2 before:z-[-1] before:block before:h-full before:w-full before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-3xl before:bg-[#FEEFD0]'
                                                }
                                            >
                                                Coming Soon
                                            </span>
                                        )}
                                    </div>
                                </th>
                                <td className={'text-center align-middle'}>
                                    {feature.type === 'boolean' ? (
                                        starterFeatures[feature.key] ? (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/check-circle-blue.svg'
                                                    }
                                                    alt={
                                                        'referral software check circle blue'
                                                    }
                                                />
                                            </span>
                                        ) : (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/stroke-dark.svg'
                                                    }
                                                    alt={'referral software stroke dark'}
                                                />
                                            </span>
                                        )
                                    ) : (
                                        starterFeatures[feature.key]
                                    )}
                                </td>
                                <td className={'text-center align-middle'}>
                                    {feature.type === 'boolean' ? (
                                        basicFeatures[feature.key] ? (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/check-circle-blue.svg'
                                                    }
                                                    alt={
                                                        'referral software check circle blue'
                                                    }
                                                />
                                            </span>
                                        ) : (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/stroke-dark.svg'
                                                    }
                                                    alt={'referral software stroke dark'}
                                                />
                                            </span>
                                        )
                                    ) : (
                                        basicFeatures[feature.key]
                                    )}
                                </td>
                                <td className={'text-center align-middle'}>
                                    {feature.type === 'boolean' ? (
                                        proFeatures[feature.key] ? (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/check-circle-blue.svg'
                                                    }
                                                    alt={
                                                        'referral software check circle blue'
                                                    }
                                                />
                                            </span>
                                        ) : (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/stroke-dark.svg'
                                                    }
                                                    alt={'referral software stroke dark'}
                                                />
                                            </span>
                                        )
                                    ) : (
                                        proFeatures[feature.key]
                                    )}
                                </td>
                                <td className={'rounded-r-3xl pr-4 text-center align-middle'}>
                                    {feature.type === 'boolean' ? (
                                        enterpriseFeatures[feature.key] ? (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/check-circle-blue.svg'
                                                    }
                                                    alt={
                                                        'referral software check circle blue'
                                                    }
                                                />
                                            </span>
                                        ) : (
                                            <span className={'inline-block'}>
                                                <img
                                                    src={
                                                        '/assets/images/svg/web/stroke-dark.svg'
                                                    }
                                                    alt={'referral software stroke dark'}
                                                />
                                            </span>
                                        )
                                    ) : (
                                        enterpriseFeatures[feature.key]
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className={'text-dark medium:block mx-auto hidden max-w-lg'}>
                <div className={'px-4'}>
                    <h5 className={'text-2xl font-bold'}>{__('Site plans')}</h5>
                    <div className={'mt-3 flex items-center gap-2.5'}>
                        <p className={'font-normal'}>Annual discount</p>
                        <ReactSwitch
                            id='toggle-plan'
                            isOn={yearlyOn}
                            handleToggle={handleChangePlanType}
                        />
                    </div>
                </div>

                {Object.values(subscriptions).map((plan, index) => {
                    const isProOrEnterprise =
                        plan.name.toLowerCase() === 'pro' ||
                        plan.name.toLowerCase() === 'enterprise';
                    const buttonLabel = isProOrEnterprise
                        ? __('Get a demo')
                        : __('Start free Trial');
                    const buttonContainerType = isProOrEnterprise ? 'main' : 'second';

                    return (
                        <div className={'width-full mt-10'} key={index}>
                            <div className={'flex flex-col justify-start px-4'}>
                                <p className={'text-2xl font-bold'}>{plan.name}</p>
                                <p className={'mt-3 text-xl font-normal'}>
                                    ${plan.price['usd'] / 100}
                                    <span>/ month</span>
                                </p>
                                <p className='text-tertiary h-4 pt-1'>
                                    {yearlyOn
                                        ? `$${(plan.price['usd'] / 100) * 12} annually`
                                        : ''}
                                </p>
                                <Button
                                    containerType={buttonContainerType}
                                    onClick={() => handleRegister(isProOrEnterprise)}
                                    className={`${isProOrEnterprise ? '' : '!text-blue hover:!text-light'} !bold mt-3 w-[133px] !min-w-32 !text-base !font-semibold`}
                                    name={buttonLabel}
                                />
                            </div>
                            <div className={'mt-10'}>
                                {Object.values(features).map((feature, index) => {
                                    const planFeature = plan.features;

                                    return (
                                        <div
                                            key={index}
                                            className={`${feature.key === 'paypal_payout' && 'opacity-60'} odd:bg-surface-input relative flex min-h-12 items-center justify-between rounded-3xl px-4`}
                                        >
                                            <div className={'flex items-center text-left'}>
                                                {feature.link ? (
                                                    <a
                                                        className={
                                                            'underline hover:opacity-90'
                                                        }
                                                        href={feature.link}
                                                    >
                                                        {feature.label}
                                                    </a>
                                                ) : (
                                                    <span>{feature.label}</span>
                                                )}
                                                {feature.tooltip && (
                                                    <div>
                                                        <div className='group relative flex cursor-pointer justify-center'>
                                                            <span
                                                                data-tooltip-target={
                                                                    feature.type
                                                                }
                                                                className={
                                                                    'group ml-2 flex items-center justify-center'
                                                                }
                                                            >
                                                                <img
                                                                    src={
                                                                        '/assets/images/svg/web/info-circle.svg'
                                                                    }
                                                                    alt={
                                                                        'referral software info circle'
                                                                    }
                                                                />
                                                            </span>
                                                            <span className='bg-dark text-light absolute left-full top-1/2 z-10 w-32 -translate-y-1/2 scale-0 rounded p-2 text-xs transition-all group-hover:scale-100'>
                                                                {feature.tooltip}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                                {feature.key === 'paypal_payout' && (
                                                    <span
                                                        className={
                                                            'text-yellow small:text-[10px] small:leading-3 relative ml-2 block p-2 text-base leading-4 before:absolute before:left-1/2 before:top-1/2 before:z-[-1] before:block before:h-full before:w-full before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-3xl before:bg-[#FEEFD0]'
                                                        }
                                                    >
                                                        Coming Soon
                                                    </span>
                                                )}
                                            </div>
                                            <div className={'flex items-center text-center'}>
                                                {feature.type === 'boolean' ? (
                                                    planFeature[feature.key] ? (
                                                        <span className={'inline-block'}>
                                                            <img
                                                                src={
                                                                    '/assets/images/svg/web/check-circle-blue.svg'
                                                                }
                                                                alt={
                                                                    'referral software check circle blue'
                                                                }
                                                            />
                                                        </span>
                                                    ) : (
                                                        <span className={'inline-block'}>
                                                            <img
                                                                src={
                                                                    '/assets/images/svg/web/stroke-dark.svg'
                                                                }
                                                                alt={
                                                                    'referral software stroke dark'
                                                                }
                                                            />
                                                        </span>
                                                    )
                                                ) : (
                                                    planFeature[feature.key]
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default PricingTable;
